import React from 'react';
import './formActions.css';

export default ({ children }) => (
  <div className="component-form-actions">{children}</div>
);
